export enum QueryParamName {
  Page = "page",
  Sort = "sort",
  Facets = "facets",
  Keyword = "keyword",
  ItemsPerPage = "size",
  SearchPhrase = "q",
}
